"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excavatorColumnFullWidthProps = exports.excavatorColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.excavatorColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'excavator_no',
        title: 'Excavator No',
        width: '175',
        filter: 'text'
    },
    {
        show: true,
        field: 'excavator_spec',
        title: 'Excavator Spec',
        width: '175',
        filter: 'text'
    },
    {
        show: true,
        field: 'excavator_capacity',
        title: 'Excavator Capacity',
        width: '175',
        filter: 'numeric'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.excavatorColumnFullWidthProps = [
    ...exports.excavatorColumnProps
];
exports.excavatorColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor_name',
    title: 'Contractor',
    width: 'auto',
    filter: 'text'
};
